// Define a generic type for form fields
import { AutocompleteType } from '../planning/autocomplete.service';

export interface EntityField {
    name: string;
    type: FieldType;
    autocomplete?: AutocompleteType;
    extraFields?: string[];
    key?: string;
    validators?: {
        minLength?: number;
        maxLength?: number;
        min?: number;
        max?: number;
        required?: boolean;
        pattern?: RegExp;
        decimals?: number;
        minDate?: Date;
        maxDate?: Date;
    };
    options?: {
        name: string;
        key: string;
    }[];
    multiple?: boolean;
    checked?: boolean;
    disabled?: boolean;
    dataFilter?: string[];
    default?: string | number | boolean;
    required?: boolean;
    disableServersideRequiredTillId?: number;
    requiredRules?: {
        field: string; // werkt op dit moment alleen met planning en planningData
        hasValue: any[];
    }[];
    atLeastOneRequiredRules?: {
        field: string; // the field to watch (e.g., status_key in planning)
        hasValue: any[]; // when this field has one of these values
        requiredFields: string[]; // at least one of these fields must be filled (works with phe/pheData fields)
    }[];
    disableRules?: {
        field: string; // the field to watch
        hasValue: any[]; // disable when this field has one of these values
        disableFields: string[]; // fields to disable
    }[];
    asyncValidators?: {
        type: string; // validator identifier (e.g., 'localUserIsAvailable')
        config?: {
            beginDateField?: string;
            endDateField?: string;
            ownIdField?: string;
            [key: string]: any; // allow for other configuration options
        };
    }[];
    icon?: string | null;
    classes?: string;
    displayPercent?: number;
    displayOrder?: number;
    statusType?: string;
}

export type EntityFormFields = {
    [key: string]: EntityField;
} | null;

export interface DayReportFieldGroup {
    label: string;
    fields: Record<string, EntityField>;
}

export type DayReportFieldGroups = Record<string, DayReportFieldGroup>;

export class EntityType {
    key?: string | EntityTypeCode;
    name: string;
    plural_name: string;
    icon: string | null;
    order: number;
    has_realisations: boolean;
    is_team: boolean;
    has_driver: boolean;
    has_lowloader: boolean;
    has_truck: boolean;
    has_preferred_team: boolean;
    has_employees: boolean;
    has_default_asphalt_performer: boolean;
    has_default_performer: boolean;
    has_entitytype_keys?: string[];
    has_employee_roles?: any[]; // associated employee's based on roles
    may_edit_roles?: any[];
    may_edit_own_roles?: any[];
    force_wide: boolean;
    visible_overview: boolean;
    visible_transport: boolean;
    visible_small: boolean;
    afas_name: string | null;
    created_at?: string;
    updated_at?: string;
    belongs_to?: string | null;
    fields_planning?: EntityFormFields;
    fields_planning_data?: EntityFormFields;
    fields_phe?: EntityFormFields;
    fields_phe_data?: EntityFormFields;
    fields_dayreport?: DayReportFieldGroups | null;
    multi_select?: boolean;

    pivot?: {
        order: number;
    };

    public constructor(init?: Partial<EntityType>) {
        Object.assign(this, init);
    }
}

export enum FieldType {
    ProgressDates = 'progress_dates',
    Label = 'label',
    Text = 'text',
    Textarea = 'textarea',
    Number = 'number',
    Date = 'date',
    Time = 'time',
    DateTime = 'datetime',
    Select = 'select',
    Checkbox = 'checkbox',
    Radio = 'radio',
    UserId = 'user_id',
    UserIdWithLeaves = 'user_id_with_leaves',
    EntityId = 'entity_id',
    StatusKey = 'status_key',
    ProjectId = 'project_id',
    Location = 'location',
    BaseDateTime = 'base_datetime',
    CustomerId = 'customer_id',
    PersonId = 'person_id',
    Hiring = 'hiring',
    Empty = 'empty',
}

export enum EntityTypeCode {
    Set = 'set',
    Cutter = 'cutter',
    Wipetruck = 'wipeTruck',
    Truck = 'truck',
    AsfaltTeam = 'asfaltTeam',
    Dumper = 'dumper',
    HirePeople = 'hirePeople',
    LowLoader = 'lowLoader',
    ProjectTeam = 'projectTeam',
    PreparationTeam = 'preparationTeam',
    AsfaltTruck = 'asfaltTruck',
    CutterTruck = 'cutterTruck',
    Crane = 'crane',
    Roller = 'roller',
    StickyWagon = 'stickyWagon',
    Keet = 'golfCart',
    AsphaltOther = 'asphaltOther',
    Other = 'other',
    Trilplaat = 'vibratingPlate',
    InhuurPersoneel = 'hiringStaff',
    VkmMateriaal = 'vkmMaterial',
    VkmPreparation = 'vkmPreparation',
    VkmWorkOrder = 'vkmWorkOrder',
    Personenauto = 'passengerCar',
}

export enum EntityId {
    HiringEmployee = 1000,
    HiringMaterials = 1001,
}

export enum UserId {
    HiringPerformer = 1111,
}
